export const joyrideAuditClass = (title) => {
  let classAudit = "";
  if (title === "Roles") {
    classAudit = "j_r_audit";
  } else if (title === "Security Groups") {
    classAudit = "j_gp_adt";
  } else if (title === "Users available in system") {
    classAudit = "j_u_audit";
  } else if (
    title?.props?.children?.props?.children?.props?.children === "Report List"
  ) {
    classAudit = "j_rep_aud";
  } else if (title === "User Security Request") {
    classAudit = "j_req_audit";
  } else if (title === "Administrator Configuration") {
    classAudit = "j_st_audit";
  }
  return classAudit;
};
